import { render, staticRenderFns } from "./IconBack.vue?vue&type=template&id=6db57971"
import script from "./IconBack.vue?vue&type=script&lang=js"
export * from "./IconBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports